import { render, staticRenderFns } from "./UsersEmailOcassion.vue?vue&type=template&id=272a7b38&scoped=true"
import script from "./UsersEmailOcassion.vue?vue&type=script&lang=js"
export * from "./UsersEmailOcassion.vue?vue&type=script&lang=js"
import style0 from "./UsersEmailOcassion.vue?vue&type=style&index=0&id=272a7b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a7b38",
  null
  
)

export default component.exports